<template>
    <div v-if="!monitor_others">
        <div v-if="can('edit-before-lockdate') && hrNotifications.length > 0" class="card shadow mb-2">
            <div class="card-body">
                <h2 class="d-inline">{{ $trans.get('__JSON__.Notifications') }}</h2>
                <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge"
                    style="font-size: 0.7rem; transform: translateY(-0.7rem);">{{ hrNotifications.length }}</div>
                <div v-if="errorInGroup.length" class="alert alert-danger">{{ $trans.get('__JSON__.' + notifications_error.error_msg) }}</div>
                <table class="table table-striped hover-zoom">
                    <thead>
                        <tr>
                            <th class="w-60">{{ $trans.get('__JSON__.Notification') }}</th>
                            <th role="button" @click.prevent="sortColumn = 'created_at'" class="w-10">{{
                                $trans.get('__JSON__.Time') }} <i v-if="sortColumn == 'created_at'"
                                    class="fa fa-sort-asc"></i>
                            </th>
                            <th class="w-10">{{ $trans.get('__JSON__.Responsible') }}</th>
                            <th class="w-20">{{ $trans.get('__JSON__.Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="notification in hrNotifications" :key="'hr-' + notification.id">
                            <tr>
                                <!-- ...existing notification row content... -->
                                <td>
                                    <a v-if="notification.link" :href="notification.link">
                                        {{ getMessage(notification.contextdata, notification.message) }}
                                    </a>
                                    <a v-else>
                                        {{ getMessage(notification.contextdata, notification.message) }}
                                    </a>
                                    <a v-if="notification.notification_type_id == 12 || notification.notification_type_id == 35"
                                        :href="'/employees/' + notification.reference + '/stamps?day=' + notification.reference_date"
                                        class="link float-end">
                                        <i class="fas fa-stamp"></i>
                                        {{ $trans.get('__JSON__.Stamps') }}
                                    </a>
                                </td>
                                <td>
                                    <i v-if="isYesterdayOrBefore(notification.created_at)" class="fa fa-warning text-danger"
                                        v-tooltip :title="$trans.get('__JSON__.Notification older than one day')"></i>
                                    {{ toYMDHMFormat(notification.created_at) }}
                                </td>
                                <!-- column(3) start, one column in three diffrent versions -->
                                <td v-if="notification.team_id && !notification.user_id" class="fw-bold">
                                    <span data-bs-html="true" v-tooltip :title="getTeamLeads(notification.team.leads)">
                                        {{ notification.team.name }}
                                    </span>
                                </td>
                                <td v-if="notification.user_id && !notification.team_id" class="fw-bold">{{
                                    notification.user.name }}
                                    <i class="fa fa-exclamation-triangle text-danger"></i>
                                </td>
                                <td v-if="notification.user_id && notification.team_id" class="fw-bold">
                                    {{ notification.team.name }} <br> {{ notification.user.name }}
                                    <i class="fa fa-exclamation-triangle text-danger"></i>
                                </td>
                                <td v-if="notification.role" class="fw-bold">{{ notification.role }}
                                    <i class="fa fa-exclamation-triangle text-danger"></i>
                                </td>
                                <!-- column(3) end -->
                                <td>
                                    <div v-if="hasEditButton(notification)">
                                        <div v-if="notification.link">
                                            <a :href="notification.link" class="btn btn-secondary d-inline-block">
                                                {{ $trans.get('__JSON__.Edit') }}
                                            </a>
                                        </div>
                                        <div v-else-if="!notification.link && hasOIMEditButton(notification)">
                                            <a :href="'/oimappointments/' + notification.oimappointments.id + '/edit'"
                                                class="btn btn-secondary d-inline-block">{{ $trans.get('__JSON__.Edit')
                                                }}</a>
                                        </div>
                                    </div>
                                    <div class="justify-content-start" v-else-if="isVacationRevoke(notification)">
                                        <a href="" @click.prevent="confirmRevokeRequest(notification)" v-tooltip
                                            :title="$trans.get('__JSON__.Accept')"
                                            class="btn btn-success ml-2 mr-2 float-start">
                                            <span class="material-symbols-outlined align-middle" style="font-size:20px;">
                                                check_circle
                                            </span>
                                        </a>
                                        <a href="" @click.prevent="denyRevokeRequest(notification)" v-tooltip
                                            :title="$trans.get('__JSON__.Deny')" class="btn btn-danger float-start">
                                            <span class="material-symbols-outlined align-middle" style="font-size:20px;">
                                                cancel
                                            </span>
                                        </a>
                                    </div>
                                    <div class="justify-content-start" v-else>
                                        <a href="" @click.prevent="acknowledgeNotification(notification)"
                                            class="btn btn-primary float-start"
                                            :class="{ 'd-none': !notification.acknowledgeable }">
                                            {{ $trans.get('__JSON__.Acknowledge') }}
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>

        <div v-if="otherNotifications.length > 0" class="card shadow">
            <div class="card-body">
                <h2 class="d-inline">{{ can('edit-before-lockdate') ? $trans.get('__JSON__.Open Notifications') : $trans.get('__JSON__.Notifications') }}</h2>
                <div class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge"
                    style="font-size: 0.7rem; transform: translateY(-0.7rem);">{{ otherNotifications.length }}</div>
                <div v-if="errorInGroup.length" class="alert alert-danger">{{ $trans.get('__JSON__.' + notifications_error.error_msg) }}</div>
                <table class="table table-striped hover-zoom">
                    <thead>
                        <tr>
                            <th class="w-60">{{ $trans.get('__JSON__.Notification') }}</th>
                            <th role="button" @click.prevent="sortColumn = 'created_at'" class="w-10">{{
                                $trans.get('__JSON__.Time') }} <i v-if="sortColumn == 'created_at'"
                                    class="fa fa-sort-asc"></i>
                            </th>
                            <th class="w-10">{{ $trans.get('__JSON__.Responsible') }}</th>
                            <th class="w-20">{{ $trans.get('__JSON__.Actions') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="notification in otherNotifications" :key="'other-' + notification.id">
                            <tr>
                                <!-- Same notification row content as above -->
                                <td>
                                    <!-- {{ notification.notification_type_id }} --> 
                                    <a v-if="notification.link" :href="notification.link">
                                        {{ getMessage(notification.contextdata, notification.message) }}
                                    </a>
                                    <a v-else>
                                        {{ getMessage(notification.contextdata, notification.message) }}
                                    </a>
                                    <a v-if="notification.notification_type_id == 12 || notification.notification_type_id == 35"
                                        :href="'/employees/' + notification.reference + '/stamps?day=' + notification.reference_date"
                                        class="link float-end">
                                        <i class="fas fa-stamp"></i>
                                        {{ $trans.get('__JSON__.Stamps') }}
                                    </a>
                                </td>
                                <td>
                                    <i v-if="isYesterdayOrBefore(notification.created_at)" class="fa fa-warning text-danger"
                                        v-tooltip :title="$trans.get('__JSON__.Notification older than one day')"></i>
                                    {{ toYMDHMFormat(notification.created_at) }}
                                </td>
                                <!-- column(3) start, one column in three diffrent versions -->
                                <td v-if="notification.team_id && !notification.user_id" class="fw-bold">
                                    <span data-bs-html="true" v-tooltip :title="getTeamLeads(notification.team.leads)">
                                        {{ notification.team.name }}
                                    </span>
                                </td>
                                <td v-if="notification.user_id && !notification.team_id" class="fw-bold">{{
                                    notification.user.name }}
                                    <i class="fa fa-exclamation-triangle text-danger"></i>
                                </td>
                                <td v-if="notification.user_id && notification.team_id" class="fw-bold">
                                    {{ notification.team.name }} <br> {{ notification.user.name }}
                                    <i class="fa fa-exclamation-triangle text-danger"></i>
                                </td>
                                <td v-if="notification.role" class="fw-bold">{{ notification.role }}
                                    <i class="fa fa-exclamation-triangle text-danger"></i>
                                </td>
                                <!-- column(3) end -->
                                <td>
                                    <div v-if="hasEditButton(notification)">
                                        <div v-if="notification.link">
                                            <a :href="notification.link" class="btn btn-secondary d-inline-block">
                                                {{ $trans.get('__JSON__.Edit') }}
                                            </a>
                                        </div>
                                        <div v-else-if="!notification.link && hasOIMEditButton(notification)">
                                            <a :href="'/oimappointments/' + notification.oimappointments.id + '/edit'"
                                                class="btn btn-secondary d-inline-block">{{ $trans.get('__JSON__.Edit')
                                                }}</a>
                                        </div>
                                    </div>
                                    <div class="justify-content-start" v-else-if="isVacationRevoke(notification)">
                                        <a href="" @click.prevent="confirmRevokeRequest(notification)" v-tooltip
                                            :title="$trans.get('__JSON__.Accept')"
                                            class="btn btn-success ml-2 mr-2 float-start">
                                            <span class="material-symbols-outlined align-middle" style="font-size:20px;">
                                                check_circle
                                            </span>
                                        </a>
                                        <a href="" @click.prevent="denyRevokeRequest(notification)" v-tooltip
                                            :title="$trans.get('__JSON__.Deny')" class="btn btn-danger float-start">
                                            <span class="material-symbols-outlined align-middle" style="font-size:20px;">
                                                cancel
                                            </span>
                                        </a>
                                    </div>
                                    <div class="justify-content-start" v-else>
                                        <a href="" @click.prevent="acknowledgeNotification(notification)"
                                            class="btn btn-primary float-start"
                                            :class="{ 'd-none': !notification.acknowledgeable }">
                                            {{ $trans.get('__JSON__.Acknowledge') }}
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div v-if="monitor_others" v-for="(group, groupName, groupIndex) in notifications" class="card shadow mb-2">
        <div class="card-body" v-if="group.length > 0">
            <h2>{{ $trans.get('__JSON__.' + group[0].notification_types?.description) }} <div
                    class="pt-1 pb-1 ps-2 pe-2 bg-danger text-white rounded-1 badge"
                    style="font-size: 0.7rem; transform: translateY(-0.7rem);">{{ group.length }}</div>
            </h2>
            <div v-if="errorInGroup == groupName" class="alert alert-danger">{{ $trans.get('__JSON__.' + notifications_error.error_msg) }}</div>
            <table class="table table-striped hover-zoom">
                <thead>
                    <tr>
                        <th class="w-60">{{ $trans.get('__JSON__.Notification') }}</th>
                        <th class="w-10">{{ $trans.get('__JSON__.Time') }}</th>
                        <th class="w-10">{{ $trans.get('__JSON__.Responsible') }}</th>
                        <th class="w-20">{{ $trans.get('__JSON__.Actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="notification in group" :key="'no-' + notification.id + groupIndex">
                        <!-- {{ notification }} -->
                        <td>
                            <a v-if="notification.link" :href="notification.link">
                                {{ getMessage(notification.contextdata, notification.message) }}
                            </a>
                            <a v-else>
                                {{ getMessage(notification.contextdata, notification.message) }}
                            </a>
                            <a v-if="notification.notification_type_id == 12"
                                :href="'/employees/' + notification.reference + '/stamps?day=' + notification.reference_date"
                                class="link float-end">
                                <i class="fas fa-stamp"></i>
                                {{ $trans.get('__JSON__.Stamps') }}
                            </a>
                        </td>
                        <td>
                            <i v-if="isYesterdayOrBefore(notification.created_at)" class="fa fa-warning text-danger"
                                v-tooltip :title="$trans.get('__JSON__.Notification older than one day')"></i>
                            {{ toYMDHMFormat(notification.created_at) }}
                        </td>
                        <!-- column(3) start, one column in three diffrent versions -->
                        <td class="fw-bold">
                            <span v-if="notification.team_id" data-bs-html="true" v-tooltip
                                :title="getTeamLeads(notification.team.leads)">
                                {{ notification.team.name }}
                            </span>
                            <span v-if="notification.user_id">{{ notification.user.name }}</span>
                            <span v-if="notification.role">{{ notification.role }}</span>
                        </td>
                        <!-- column(3) end -->
                        <td>
                            <div v-if="hasEditButton(notification)">
                                <div v-if="notification.link">
                                    <a :href="notification.link" class="btn btn-secondary d-inline-block">
                                        {{ $trans.get('__JSON__.Edit') }}
                                    </a>
                                </div>
                                <div v-else-if="!notification.link && hasOIMEditButton(notification)">
                                    <a :href="'/oimappointments/' + notification.oimappointments.id + '/edit'"
                                        class="btn btn-secondary d-inline-block">{{ $trans.get('__JSON__.Edit')
                                        }}</a>
                                </div>
                            </div>
                            <div v-else-if="isVacationRevoke(notification)">
                                <a href="" @click.prevent="confirmRevokeRequest(notification, groupName)" v-tooltip
                                    :title="$trans.get('__JSON__.Accept')" class="btn btn-success mr-2 float-start">
                                    <span class="material-symbols-outlined align-middle" style="font-size:20px;">
                                        check_circle
                                    </span>
                                </a>
                                <a href="" @click.prevent="denyRevokeRequest(notification, groupName)" v-tooltip
                                    :title="$trans.get('__JSON__.Deny')" class="btn btn-danger float-start">
                                    <span class="material-symbols-outlined align-middle" style="font-size:20px;">
                                        cancel
                                    </span>
                                </a>
                            </div>
                            <div class="justify-content-start" v-else>
                                <a href="" @click.prevent="acknowledgeNotification(notification, groupName)"
                                    class="btn btn-primary float-start"
                                    :class="{ disabled: !notification.acknowledgeable }">
                                    {{ $trans.get('__JSON__.Acknowledge') }}
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <!-- </div> -->
</template>
<style></style>

<script>
import getNotifications from "../composables/notifications";

export default {

    name: "Notifications",

    props: {
        monitor_others: Boolean,
        view_locations: Object
    },
    setup(props) {
        const { notifications, notifications_error, loadNotifications, putDenyRevokeRequest, putConfirmRevokeRequest, putAcknowledgeNotification } = getNotifications();
        loadNotifications(props.monitor_others, props.view_locations);

        return {
            notifications, notifications_error, loadNotifications, putDenyRevokeRequest, putConfirmRevokeRequest, putAcknowledgeNotification
        };
    },
    data() {
        return {
            sortColumn: 'created_at',
            counted: null,
            errorInGroup: [],
        };
    },
    created() {
        let refreshtime = 600000 + Math.floor(Math.random() * 120000);
        setInterval(this.refreshData, refreshtime)
    },
    watch: {
        notifications: {
            handler(newNotifications) {
                if (Array.isArray(newNotifications)) {
                    newNotifications.forEach(notification => {
                        if (notification.notification_type_id == 44) {
                            notification.acknowledgeable = false;
                            this.vacationCheck(notification.reference).then(result => {
                                notification.acknowledgeable = !result;
                            });
                        }
                        else
                            notification.acknowledgeable = true;
                    });
                }
            }
        }
    },
    computed: {
        sortedNotifications() {
            if (!this.notifications) {
                $('#notificationsContainer').css('display', 'none');
                return null;
            }
            if (this.notifications.length == 0) {
                $('#notificationsContainer').css('display', 'none');
                return null;
            }
            $('#notificationsContainer').css('display', 'block');
            return this.notifications.sort(this.compareNotifications);
        },
        hrNotifications() {
            if (!this.notifications || !Array.isArray(this.notifications)) {
                return [];
            }
            return this.notifications.filter(notification => notification.role === 'HR').sort(this.compareNotifications);
        },
        otherNotifications() {
            if (!this.notifications || !Array.isArray(this.notifications)) {
                return [];
            }
            if (this.can('edit-before-lockdate')) {
                return this.notifications.filter(notification => notification.role !== 'HR').sort(this.compareNotifications);
            }
            return this.notifications.sort(this.compareNotifications);
        }
    },
    methods: {
        toYMDFormat(dateString) { // yyyy-mm-dd
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd;

            return formattedDate;

        },
        toYMDHMFormat(dateString) { // yyyy-mm-dd hh:mi
            if (dateString == null) {
                return null;
            }
            var date = new Date(dateString);
            var mm = date.getMonth() + 1;
            mm = mm.toString().padStart(2, '0');
            var yyyy = date.getFullYear();
            var dd = date.getDate().toString().padStart(2, '0');
            var hh = date.getHours().toString().padStart(2, '0');
            var mi = date.getMinutes().toString().padStart(2, '0');

            var formattedDate = yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi;

            return formattedDate;

        },
        compareNotifications(a, b) {
            if (this.sortColumn == 'created_at') {
                if (a.notification_type_id < b.notification_type_id) {
                    return 1;
                }
                if (a.notification_type_id > b.notification_type_id) {
                    return 0;
                }
                if (a.created_at == b.created_at) {
                    return 1;
                }
                if (a.created_at < b.created_at) {
                    return -1;
                }
                return 0;
            }
            return 1;
        },
        getCountNotifications() {
            if (!this.notifications) {
                return counted = 0;
            }
            let counted = this.notifications.length;
            return counted;
        },
        getMessage(contextData, message) {
            let messagetext = this.$trans.get('__JSON__.' + message);
            let data = JSON.parse(contextData);
            for (const key in data) {
                messagetext = messagetext.replace(':' + key, data[key])
            };
            if (messagetext.startsWith('__JSON__.')) {
                messagetext = messagetext.substring(9);
            }
            return messagetext;
        },
        isYesterdayOrBefore(date) {
            var d = new Date();
            d.setDate(d.getDate() - 1);
            if (Date.parse(date) <= Date.parse(d)) {
                return true;
            }
            return false;
        },
        makeFullname(lastname, forename) {
            const fullname = lastname + ', ' + forename;
            return fullname;
        },
        getTeamLeads(leads) {
            let teamLeads = '';
            leads.forEach(function (arrayItem) {
                teamLeads += arrayItem.lastname + ", " + arrayItem.forename + "</br>";
            }
            );
            return teamLeads;
        },
        hasEditButton(notification) {
            let notificationTypeIds = [
                13, 12, 9, 4, 7, 3, 1, 21, 35, 49
            ];

            return notificationTypeIds.includes(notification.notification_type_id);
        },
        hasOIMEditButton(notification) {
            return notification.notification_type_id == 21;
        },
        isVacationRevoke(notification) {
            return notification.notification_type_id == 30;
        },
        async denyRevokeRequest(notificationObj, groupIndex = null) {
            $(".tooltip").css('display', 'none');
            await this.putDenyRevokeRequest(notificationObj);
            this.filterNotifications(notificationObj.id, groupIndex);
        },
        async confirmRevokeRequest(notificationObj, groupIndex = null) {
            $(".tooltip").css('display', 'none');
            await this.putConfirmRevokeRequest(notificationObj);
            if(this.notifications_error !== null) {
                this.errorInGroup.push(groupIndex);
            }
            this.filterNotifications(notificationObj.id, groupIndex);
        },
        async acknowledgeNotification(notificationObj, groupIndex = null) {
            $(".tooltip").css('display', 'none');
            await this.putAcknowledgeNotification(notificationObj);
            this.filterNotifications(notificationObj.id, groupIndex);
        },
        filterNotifications(filterId, groupId = null) {
            if (this.notifications_error === null) {
                if (groupId !== null) {
                    this.notifications[groupId] = this.notifications[groupId].filter(function (value, index, arr) {
                        return value.id != filterId;
                    });
                } else {
                    this.notifications = this.notifications.filter(function (value, index, arr) {
                        return value.id != filterId;
                    });
                }
            }
        },
        refreshData() {
            this.errorInGroup = [];
            this.loadNotifications(this.monitor_others, this.view_locations);
        },
        async vacationCheck(employeeId) {
            try {
                const response = await axios.get(`/api/checkremainingvacation/${employeeId}`);
                return response.data.vacationCheck;
            } catch (error) {
                console.error('Error checking remaining vacation:', error);
                return false;
            }
        },
    }
}

</script>